import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AppContext } from '@/contexts/AppContext/AppContextProvider.tsx';

export const AdminRoutes = () => {
	const { admin } = useContext(AppContext);

	if (!admin) {
		return <Navigate to={'/'} replace />;
	}

	return <Outlet />;
};
